import { SEARCH_FIELD_OTHERS, SEARCH_FIELD_PAGES, SEARCH_FIELD_PRODUCTS } from 'Query/Search.query';

export const SEARCH_RESULTS_TAB_LABELS = {
    [SEARCH_FIELD_PRODUCTS]: __('Produits'),
    [SEARCH_FIELD_PAGES]: __('Tutos'),
    [SEARCH_FIELD_OTHERS]: __('Autres')
};
